import type { IDeepSearchProgressPayload } from "../../types/chat";
import type { IDeepSearchProgressUpdate } from "./types";

// NOTE: NSAI-6435 — what a `deepSearchProgress` event writes on its message:
// the live progress (with the round, the cost so far and the report check's
// count) and, from a v2 run, its progress record. Shared so the web and
// mobile handlers, and the web's background tracker, read an event the same
// way.
export const readDeepSearchProgressEvent = (
  payload: IDeepSearchProgressPayload,
): IDeepSearchProgressUpdate => ({
  progress: {
    status: payload.status,
    message: payload.message,
    query: payload.query,
    queryIndex: payload.queryIndex,
    totalQueries: payload.totalQueries,
    completedCount: payload.completedCount,
    round: payload.round,
    spend: payload.spend,
    claimsChecked: payload.claimsChecked,
    claimsTotal: payload.claimsTotal,
  },
  researchProgress: payload.researchProgress,
});
